import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export type FormulaFn =
  | 'alias'
  | 'substring'
  | 'sepstring'
  | 'joinstring'
  | 'datestring'
  | 'format'
  | 'case'
  | 'array'
  | 'calc'
  | 'round'
  | 'ceiling'
  | 'floor'
  | 'count'
  | 'sum'
  | 'min'
  | 'max'
  | 'rowNo'
  | 'viewNo'
  | 'expandNo'
  | 'listagg'
  | 'guid'
  | 'ulid'
  | 'now'
  | 'iif';

export type FormulaControlPayload = {
  kind: 'formulaControl';
  fn: FormulaFn;
  // 関数ごとの定数パラメータ（必要になった分だけ追加）
  digits?: number; // round/ceiling/floor
  joinChar?: string; // joinstring
  dateFormat?: string; // datestring
  listaggOptions?: 'list' | 'distinct';
  onChange: (next: Partial<Omit<FormulaControlPayload, 'kind' | 'onChange'>>) => void;
};

@Component({
  selector: 'app-formula-control',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './formula-control.component.html',
  styleUrl: './formula-control.component.scss',
})
export class FormulaControlComponent {
  @Input({ required: true }) data!: FormulaControlPayload;

  changeFn(next: string): void {
    this.data.onChange({ fn: next as FormulaFn });
  }

  changeDigits(next: string): void {
    const n = Number(next);
    this.data.onChange({ digits: Number.isFinite(n) ? n : 0 });
  }

  changeJoinChar(next: string): void {
    this.data.onChange({ joinChar: next });
  }

  changeDateFormat(next: string): void {
    this.data.onChange({ dateFormat: next });
  }

  changeListaggOptions(next: string): void {
    this.data.onChange({ listaggOptions: next as any });
  }
}

